import React from 'react'
import { useIntl } from 'react-intl'

import { IconPeople } from '@s4l/icons/IconPeople'
import RequestSentPreview from '../RequestSentPreview'

import { SpecialRequest } from '../types'
import styles from './styles.module.css'

interface IRequestSentMessage {
  specialRequests: SpecialRequest[]
}

const RequestSentMessage: React.FC<IRequestSentMessage> = ({ specialRequests }) => {
  const intl = useIntl()

  return (
    <>
      {specialRequests.map((item, index) => {
        return (
          <div key={item.requestKey ?? index} data-testid={`special-requests-${index}`}>
            {item.requestKey ? (
              <>
                <div className={styles.requestName}>{`${item.requestKey}:`}</div>
                <div className={styles.requestValue}>{item.requestValue}</div>
              </>
            ) : (
              <RequestSentPreview
                icon={IconPeople}
                title={
                  item.datetime
                    ? intl.formatTime(item.datetime, {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                      })
                    : ''
                }
              >
                <span data-testid={`comment-${index}`}>{item.requestValue}</span>
              </RequestSentPreview>
            )}
          </div>
        )
      })}
    </>
  )
}

export default RequestSentMessage
RequestSentMessage.displayName = 'RequestSentMessage'
